<template>
  <div>
    <back-button default-to="/stock-ins"/>
    <b-card no-header no-footer>
      <ValidationObserver ref="form">
        <form @submit.prevent="save('draft')">
          <b-row>
            <b-col cols="12" md="4"><form-group-input ref="tanggal_masuk" type="date" label="Tanggal Masuk" :need-label="true" v-model="model.tanggal_masuk.value" rules="required" id="tanggal_masuk" /></b-col>
            <b-col cols="12" md="4"><form-group-input ref="sumber" type="enum" label="Sumber" :need-label="true" :options="getOptions('sumber')" v-model="model.sumber.value" rules="required" id="sumber" /></b-col>
          </b-row>
          <div class="mt-2 mb-3">
            <h5>Detail Barang</h5>
            <b-btn variant="dark" @click.prevent="openStockModal"><font-awesome-icon icon="plus" /> Tambah Barang</b-btn>
            <div class="table-responsive mt-3"><table class="table table-striped"><thead><tr><th>Nama</th><th>Berat</th><th>Kadar</th><th>Jumlah</th><th></th></tr></thead><tbody>
              <tr v-if="!details.length"><td colspan="5" class="text-center text-muted">Belum ada barang.</td></tr>
              <tr v-for="(row, index) in details" :key="row.key"><td>{{ row.nama }}</td><td>{{ row.berat }} gram</td><td>{{ row.kadar || '-' }}</td><td><b-form-input v-model="row.qty" type="number" min="1" /></td><td><b-button @click.prevent="removeRow(index)" variant="danger" size="sm"><font-awesome-icon icon="trash"/></b-button></td></tr>
            </tbody></table></div>
          </div>
          <form-group-input ref="catatan" type="textarea" label="Catatan" :need-label="true" v-model="model.catatan.value" id="catatan" />
          <b-button v-if="mode === 'create' || transactionStatus === 'draft'" type="button" variant="primary" :disabled="isLoading" @click="save('pending')">Ajukan Persetujuan</b-button>
          <b-button type="submit" variant="secondary" class="ml-2" :disabled="isLoading"><font-awesome-icon icon="spinner" spin v-if="isLoading"/> {{ mode === 'update' ? 'Simpan Perubahan' : 'Simpan Draft' }}</b-button>
          <b-button to="/stock-ins" variant="secondary" class="ml-3 float-right">Batal</b-button>
        </form>
      </ValidationObserver>
    </b-card>
    <b-modal id="stock-in-add-modal" title="Pilih Stok" hide-footer>
      <b-input class="w-100 mb-3" placeholder="Ketik minimal 2 karakter: barcode atau nama" v-model="stockSearch" />
      <b-spinner v-if="stockLoading" small label="Memuat" />
      <div v-else-if="stocks.length" class="list-group">
        <a href="#" @click.prevent="selectStock(stock)" v-for="stock in stocks" :key="stock.id" class="list-group-item list-group-item-action">
          <strong>[{{ stock.stock_barcode }}] {{ stock.nama }}</strong><small class="d-block text-muted">{{ stock.jenis_barang }} · {{ stock.kadar || '-' }} · saldo {{ formatBalance(stock) }}</small>
        </a>
      </div>
      <p v-else class="text-center text-muted">{{ pickerMessage }}</p>
      <div class="mt-3 text-center"><b-button v-if="stockPage > 1" size="sm" @click="loadStocks(stockPage - 1)">Sebelumnya</b-button><b-button v-if="stocks.length === 20" size="sm" class="ml-2" @click="loadStocks(stockPage + 1)">Berikutnya</b-button></div>
    </b-modal>
  </div>
</template>

<script>
import { saveProcess, objectToOptions, setModelValue } from '@/_helpers'
import formGroupInput from '@/components/FormGroupInput.vue'
import StockIn from '@/models/StockIn.js'
import Stock from '@/models/Stock.js'

const stockInModel = new StockIn()
const stockModel = new Stock()
let searchTimer = null

export default {
  components: { formGroupInput },
  data () { return { isLoading: false, model: stockInModel.init(), details: [], stocks: [], stockSearch: '', stockLoading: false, stockPage: 1, transactionStatus: 'draft' } },
  computed: {
    mode () { return this.$route.params.id ? 'update' : 'create' },
    pickerMessage () { return this.stockSearch.length < 2 ? 'Ketik minimal 2 karakter untuk mencari.' : 'Stok tidak ditemukan.' }
  },
  watch: {
    stockSearch () { clearTimeout(searchTimer); searchTimer = setTimeout(() => { this.loadStocks(1) }, 350) }
  },
  mounted () {
    if (this.mode === 'update') this.getDetail()
    else { this.model.tanggal_masuk.value = this.$moment().format('YYYY-MM-DD'); this.$nextTick(() => this.$refs.tanggal_masuk.setValue(this.model.tanggal_masuk.value)) }
  },
  methods: {
    getOptions (key) { return objectToOptions(this.model[key].options) },
    getDetail () {
      this.isLoading = true
      stockInModel.find(this.$route.params.id).then(data => {
        if (data.approval_status !== 'draft') { this.$store.dispatch('notification/error', 'Hanya Stok Masuk draft yang dapat diubah.'); this.$router.replace('/stock-ins/' + data.id); return }
        this.transactionStatus = data.approval_status
        setModelValue(this.model, data, true); this.details = data.detail_barang.map(item => ({ ...item, key: item.id }))
      }).catch(error => this.$store.dispatch('notification/error', error)).finally(() => { this.isLoading = false })
    },
    openStockModal () { this.stockSearch = ''; this.stocks = []; this.stockPage = 1; this.$bvModal.show('stock-in-add-modal') },
    loadStocks (page) {
      if (this.stockSearch.length < 2) { this.stocks = []; return }
      this.stockLoading = true; this.stockPage = page
      stockModel.list({ nama_barcode: this.stockSearch, limit: 20, page, order: 'nama', ascending: 1 }).then(response => { this.stocks = response.data.data || [] }).catch(error => this.$store.dispatch('notification/error', error)).finally(() => { this.stockLoading = false })
    },
    formatBalance (stock) { const unit = stock.inventory_unit === 'gram' ? 'gram' : 'buah'; const amount = Number(stock.stock_balance || 0); return (stock.inventory_unit === 'gram' ? amount.toLocaleString('id-ID', { minimumFractionDigits: 3, maximumFractionDigits: 3 }) : amount.toLocaleString('id-ID', { maximumFractionDigits: 0 })) + ' ' + unit },
    selectStock (stock) {
      if (this.details.find(row => Number(row.stock_id) === Number(stock.id))) { this.$store.dispatch('notification/error', 'Barang sudah ditambahkan.'); return }
      this.details.push({ key: Date.now() + Math.random(), stock_id: stock.id, nama: stock.nama, jenis_barang: stock.jenis_barang, berat: stock.berat, kadar: stock.kadar, qty: 1 })
      this.$bvModal.hide('stock-in-add-modal')
    },
    removeRow (index) { this.details.splice(index, 1) },
    validateDetails () { if (!this.details.length) return 'Minimal satu barang wajib diisi.'; return this.details.some(row => !row.stock_id || !row.qty || Number(row.qty) < 1) ? 'Setiap barang harus memiliki jumlah minimal 1.' : null },
    save (status) {
      const detailError = this.validateDetails(); if (detailError) { this.$store.dispatch('notification/error', detailError); return }
      this.$refs.form.validate().then(valid => {
        if (!valid || this.isLoading) return
        this.isLoading = true
        saveProcess(this.model, this.mode === 'update').then(model => {
          model.details = this.details
          if (this.mode === 'update') return stockInModel.update(this.$route.params.id, model).then(data => status === 'pending' && this.transactionStatus === 'draft' ? stockInModel.submit(data.id) : data)
          model.approval_status = status; return stockInModel.create(model)
        }).then(data => { this.$store.dispatch('notification/success', status === 'pending' ? 'Stok Masuk berhasil diajukan.' : 'Draft Stok Masuk berhasil disimpan.'); this.$router.push('/stock-ins/' + data.id) }).catch(error => this.$store.dispatch('notification/error', error)).finally(() => { this.isLoading = false })
      })
    }
  }
}
</script>
